import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useCdnUrl } from '@packlink/provider';
import { GigerProvider } from '@shipengine/giger';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useThemeFromCDN, useIconIndexCDN } from '../hooks/useCDN.js';
import { useTenantIconResolver } from '../hooks/useIconLoader.js';
import { useHelmet } from '../hooks/useHelmet.js';

const TenantThemeProvider = _ref => {
  let {
    children,
    onLoad = () => undefined,
    additionalHeaderProps,
    headerProps,
    reference
  } = _ref;
  const cdnUrl = useCdnUrl();
  const [theme, loadingTheme] = useThemeFromCDN(cdnUrl);
  const [iconIndex, loadingIconIndex] = useIconIndexCDN(cdnUrl);
  const resolveIcon = useTenantIconResolver(cdnUrl, iconIndex);
  const helmetProps = useHelmet(additionalHeaderProps, headerProps);
  useEffect(() => {
    if (!loadingTheme && !loadingIconIndex && iconIndex) {
      onLoad(theme, iconIndex);
    }
  }, [iconIndex, loadingIconIndex, loadingTheme, onLoad, theme]);
  return jsxs(GigerProvider, {
    theme: theme,
    resolveIcon: resolveIcon,
    reference: reference,
    cdnUrl: cdnUrl,
    children: [jsx(Helmet, {
      ...helmetProps
    }), children]
  });
};

export { TenantThemeProvider };
//# sourceMappingURL=tenantThemeProvider.js.map
